import * as React from 'react'
function SvgDotArrow(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M22.495 18.084h5.348v-3.108c0-.781.963-1.163 1.515-.625l4.974 4.844a.844.844 0 010 1.232l-4.974 4.843c-.552.556-1.515.174-1.515-.607v-3.108h-5.348c-.98 0-1.783-.78-1.783-1.736 0-.954.802-1.735 1.783-1.735z"
				fill="#140309"
				fillOpacity={0.5}
			/>
			<circle cx={8.067} cy={19.817} r={1.733} fill="#140309" fillOpacity={0.5} />
			<circle cx={15.233} cy={19.817} fill="#140309" fillOpacity={0.5} r={1.733} />
		</svg>
	)
}
export default SvgDotArrow
